import { createSelector } from "reselect";
const getProducts = (state) => state.entities.products || {};
const getProductId = (_, productId) => productId;

export const getAllProducts = createSelector(
  getProducts,
  (products) => Object.values(products)
);

export const getProductById = createSelector(
  getProducts,
  getProductId,
  (products, productId) => products[productId] || null
);

export const getProductsLoading = (state) => state.productsList?.loading;
